import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { Actions, Action } from "../../ai-elements/actions.js";
import { Shimmer } from "../../ai-elements/shimmer.js";
import brandclub_colors from "../../colors/brandclubColors.js";
import { CopyIcon } from "../../icons/CopyIcon.js";
import { ShareIcon } from "../../icons/ShareIcon.js";
import { ThumbsDownIcon } from "../../icons/ThumbsDownIcon.js";
import { ThumbsUpIcon } from "../../icons/ThumbsUpIcon.js";
import React__default, { useState, useMemo, useRef, useLayoutEffect } from "react";
import { toast } from "sonner";
import { getHeadersWithUniqueVisitorId } from "../../Auth/index.js";
import { sendMessageFeedback } from "../api.js";
import { marked } from "marked";
import { ConciergeMessagePart } from "./ConciergeMessagePart/index.js";
import DevInfoPanel from "./DevInfoPanel.js";
import { StoreLocatorWidget } from "./StoreLocatorWidget/index.js";
import { OrderCardList } from "./OrderCard.js";
import { ChainOfThoughtWidget, MessageBubbleWidget, themeColor, customColor, FollowUpQueriesWidget } from "@brandclub/bc-widgets";
const RetryIcon = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M5.14258 0.570312C6.75994 -0.0514941 8.53609 -0.129008 10.2012 0.350586C11.8663 0.830234 13.3294 1.84063 14.3682 3.22754L14.4404 3.32422V1.59766C14.4404 1.39614 14.5206 1.20304 14.6631 1.06055C14.8056 0.91805 14.9987 0.837891 15.2002 0.837891C15.4017 0.837899 15.5948 0.918057 15.7373 1.06055C15.8798 1.20304 15.96 1.39615 15.96 1.59766V5.59668C15.96 5.79817 15.8798 5.9913 15.7373 6.13379C15.5948 6.27628 15.4017 6.35644 15.2002 6.35645H11.2012C10.9997 6.35645 10.8066 6.27626 10.6641 6.13379C10.5216 5.99129 10.4414 5.7982 10.4414 5.59668C10.4414 5.3952 10.5216 5.20204 10.6641 5.05957C10.8065 4.91717 10.9997 4.83691 11.2012 4.83691H13.5977L13.5635 4.77734C12.8439 3.53958 11.7309 2.57673 10.4023 2.04297C9.07395 1.50936 7.60527 1.43433 6.22949 1.83008C4.85355 2.22591 3.64943 3.07039 2.80762 4.22852C1.96581 5.38664 1.5349 6.7927 1.58301 8.22363C1.63117 9.65448 2.1556 11.0281 3.07324 12.127C3.99094 13.2259 5.24903 13.9875 6.64844 14.29C8.04782 14.5925 9.50821 14.4186 10.7979 13.7969C12.007 13.2139 13.0009 12.2681 13.6436 11.0947L13.7676 10.8574C13.8115 10.7673 13.873 10.6864 13.9482 10.6201C14.0234 10.5539 14.1112 10.503 14.2061 10.4707C14.3008 10.4385 14.4011 10.426 14.501 10.4326C14.601 10.4393 14.6993 10.4652 14.7891 10.5098C14.8787 10.5544 14.9587 10.6168 15.0244 10.6924C15.0901 10.768 15.1403 10.8561 15.1719 10.9512C15.2034 11.0461 15.2153 11.1463 15.208 11.2461C15.2006 11.3459 15.1741 11.4439 15.1289 11.5332L15.1279 11.5342C14.3581 13.0864 13.103 14.3453 11.5527 15.1191C10.0023 15.893 8.24152 16.1393 6.53809 15.8213C4.83467 15.5033 3.2811 14.6385 2.11426 13.3574C0.947501 12.0763 0.231155 10.4492 0.0732422 8.72363C-0.0846568 6.99799 0.325268 5.2675 1.24023 3.7959C2.15519 2.32452 3.52532 1.19209 5.14258 0.570312Z",
    fill: "currentColor"
  }
) });
const ChatMessageComponent = React__default.forwardRef(
  ({
    role,
    content,
    bottomRef,
    isTyping = false,
    isStreaming = false,
    isLastMessage = false,
    messageIndex,
    conversationId,
    feedback,
    followUpQueries = [],
    nextUserMessage,
    storeLocator,
    streamingStoreLocator,
    orders,
    devInfo,
    onSearch,
    onUpdateFeedback,
    onVariantSelect,
    onSuggestionClick,
    apiBaseUrl,
    isSharedView,
    uiMessageParts,
    transientStatus,
    pdpStacklineSku,
    isOnChatWidget,
    brandLogoUrl,
    followUpsLoading,
    onRetry,
    onOpenShareDialog
  }, _ref) => {
    var _a;
    const isUser = role === "user";
    const hasUiMessageParts = Array.isArray(uiMessageParts) && uiMessageParts.length > 0;
    const hasAnyContent = content.length > 0 || hasUiMessageParts && ((uiMessageParts == null ? void 0 : uiMessageParts.some((p) => p.type !== "text" || p.text)) ?? false);
    const showCursor = isStreaming && !isTyping && hasAnyContent && !(!!transientStatus && content.length === 0);
    const shimmerActive = !isTyping && isStreaming && !!transientStatus && content.length === 0;
    const [liked, setLiked] = useState((feedback == null ? void 0 : feedback.type) === "like");
    const [disliked, setDisliked] = useState((feedback == null ? void 0 : feedback.type) === "dislike");
    const [copied, setCopied] = useState(false);
    const [localSelectedFollowUp, setLocalSelectedFollowUp] = useState(void 0);
    const derivedSelectedFollowUp = useMemo(() => {
      if (!nextUserMessage || !followUpQueries.length) return void 0;
      return followUpQueries.find((query) => query === nextUserMessage);
    }, [nextUserMessage, followUpQueries]);
    const selectedFollowUp = derivedSelectedFollowUp || localSelectedFollowUp;
    const userMessageRef = useRef(null);
    const [isMultiline, setIsMultiline] = useState(false);
    const assistantContentRef = useRef(null);
    const [assistantBubbleWidth, setAssistantBubbleWidth] = useState(void 0);
    const hasWidgetParts = useMemo(
      () => Array.isArray(uiMessageParts) && uiMessageParts.some(
        (p) => !["text", "source-url", "data-follow-ups", "tool-search_products", "tool-analyze_query"].includes(p.type)
      ),
      [uiMessageParts]
    );
    useLayoutEffect(() => {
      if (!isUser || !userMessageRef.current) return;
      const el = userMessageRef.current;
      const textNode = el.firstChild;
      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const rects = range.getClientRects();
        setIsMultiline(rects.length > 1);
      } else {
        const computedStyle = window.getComputedStyle(el);
        const lineHeight = parseFloat(computedStyle.lineHeight) || parseFloat(computedStyle.fontSize) * 1.5;
        setIsMultiline(el.scrollHeight > lineHeight * 1.5);
      }
    }, [isUser, content]);
    useLayoutEffect(() => {
      if (isUser || isTyping || hasWidgetParts) {
        setAssistantBubbleWidth(void 0);
        return;
      }
      const el = assistantContentRef.current;
      if (!el) {
        setAssistantBubbleWidth(void 0);
        return;
      }
      const containerLeft = el.getBoundingClientRect().left;
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let maxRight = 0;
      let node;
      while (node = walker.nextNode()) {
        const range = document.createRange();
        range.selectNodeContents(node);
        const rects = range.getClientRects();
        for (let i = 0; i < rects.length; i++) {
          maxRight = Math.max(maxRight, rects[i].right);
        }
      }
      if (maxRight > 0) {
        const textWidth = maxRight - containerLeft;
        const computedStyle = window.getComputedStyle(el);
        const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
        const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
        const neededWidth = Math.ceil(textWidth) + paddingLeft + paddingRight + 2;
        if (neededWidth < el.offsetWidth - 8) {
          setAssistantBubbleWidth(neededWidth);
        } else {
          setAssistantBubbleWidth(void 0);
        }
      } else {
        setAssistantBubbleWidth(void 0);
      }
    }, [isUser, isTyping, content, hasUiMessageParts, hasWidgetParts]);
    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(content);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      } catch (error) {
        toast.error("Failed to copy message");
      }
    };
    const handleShare = () => {
      if (!conversationId) {
        console.warn("Cannot share: missing conversationId");
        return;
      }
      onOpenShareDialog == null ? void 0 : onOpenShareDialog(conversationId, messageIndex);
    };
    const handleLike = async () => {
      var _a2;
      if (!conversationId || messageIndex === void 0) return;
      const newState = !liked;
      setLiked(newState);
      setDisliked(false);
      try {
        const headers = await getHeadersWithUniqueVisitorId();
        const result = await sendMessageFeedback({
          conversationId,
          messageIndex,
          feedbackType: newState ? "like" : null,
          headersToInject: headers,
          apiBaseUrl
        });
        if (onUpdateFeedback && ((_a2 = result.message.metadata) == null ? void 0 : _a2.feedback)) {
          onUpdateFeedback(messageIndex, result.message.metadata.feedback);
        }
      } catch (error) {
        console.error("Failed to update feedback:", error);
        setLiked(!newState);
      }
    };
    const handleDislike = async () => {
      var _a2;
      if (!conversationId || messageIndex === void 0) return;
      const newState = !disliked;
      setDisliked(newState);
      setLiked(false);
      try {
        const headers = await getHeadersWithUniqueVisitorId();
        const result = await sendMessageFeedback({
          conversationId,
          messageIndex,
          feedbackType: newState ? "dislike" : null,
          headersToInject: headers,
          apiBaseUrl
        });
        if (onUpdateFeedback && ((_a2 = result.message.metadata) == null ? void 0 : _a2.feedback)) {
          onUpdateFeedback(messageIndex, result.message.metadata.feedback);
        }
      } catch (error) {
        console.error("Failed to update feedback:", error);
        setDisliked(!newState);
      }
    };
    const handleFollowUpClick = (query) => {
      if (!isLastMessage || selectedFollowUp) return;
      setLocalSelectedFollowUp(query);
      onSearch == null ? void 0 : onSearch(query);
    };
    const getJustifyContent = (alignment) => {
      switch (alignment) {
        case "right":
          return "flex-end";
        case "center":
          return "center";
        default:
          return "flex-start";
      }
    };
    const renderUserMessageBubble = () => /* @__PURE__ */ jsx(
      MessageBubbleWidget,
      {
        widgetId: "concierge-user-message",
        displayName: "User Message Bubble",
        initialState: {
          bgColor: customColor(brandclub_colors.blueWhite),
          textColor: themeColor("textPrimary"),
          maxWidth: "90%",
          alignment: "right"
        },
        children: (styles, resolveColor) => {
          const borderRadius = isMultiline ? styles.borderRadius : styles.borderRadiusShort;
          const fontFamily = styles.fontFamilyCss ? styles.fontFamilyCss !== "inherit" ? styles.fontFamilyCss : "var(--concierge-user-message-font-family, inherit)" : "var(--concierge-user-message-font-family, inherit)";
          return /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                alignItems: getJustifyContent(styles.alignment),
                width: "100%"
              },
              children: /* @__PURE__ */ jsx("div", { style: { maxWidth: styles.maxWidth }, children: /* @__PURE__ */ jsx(
                "div",
                {
                  className: "message-content user-message",
                  style: {
                    maxWidth: "100%",
                    minWidth: "50px",
                    backgroundColor: resolveColor(styles.bgColor),
                    color: resolveColor(styles.textColor),
                    borderRadius: `${borderRadius}px`,
                    wordWrap: "break-word",
                    padding: `${styles.paddingY}px ${styles.paddingX}px`,
                    fontSize: `${styles.fontSize}px`,
                    fontWeight: styles.fontWeight,
                    fontFamily,
                    lineHeight: styles.lineHeight,
                    ...!isMultiline && styles.singleLineHeight > 0 ? {
                      minHeight: styles.singleLineHeight,
                      display: "flex",
                      alignItems: "center",
                      boxSizing: "border-box"
                    } : {}
                  },
                  children: /* @__PURE__ */ jsx("div", { ref: userMessageRef, style: { whiteSpace: "pre-wrap" }, children: content })
                }
              ) })
            }
          );
        }
      }
    );
    const renderAssistantMessageBubble = () => /* @__PURE__ */ jsx(
      MessageBubbleWidget,
      {
        widgetId: "concierge-assistant-message",
        displayName: "Assistant Message Bubble",
        initialState: {
          bgColor: themeColor("secondary"),
          textColor: themeColor("textPrimary"),
          maxWidth: "100%",
          paddingX: 0,
          paddingY: 0,
          alignment: "left"
        },
        children: (styles, resolveColor) => /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: getJustifyContent(styles.alignment),
              width: "100%"
            },
            children: /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  maxWidth: styles.maxWidth,
                  width: hasWidgetParts ? "100%" : assistantBubbleWidth ?? void 0,
                  color: resolveColor(styles.textColor)
                },
                children: [
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      ref: assistantContentRef,
                      className: "message-content",
                      style: {
                        maxWidth: "100%",
                        minWidth: "50px",
                        backgroundColor: resolveColor(styles.bgColor),
                        color: resolveColor(styles.textColor),
                        borderRadius: `${styles.borderRadius}px`,
                        wordWrap: "break-word",
                        padding: `${styles.paddingY}px ${styles.paddingX}px`,
                        fontSize: `${styles.fontSize}px`,
                        fontWeight: styles.fontWeight,
                        lineHeight: styles.lineHeight
                      },
                      children: [
                        hasUiMessageParts ? /* @__PURE__ */ jsx(
                          ConciergeMessagePart,
                          {
                            parts: uiMessageParts,
                            onProductClick: onVariantSelect,
                            isStreaming,
                            pdpStacklineSku,
                            isOnChatWidget,
                            apiBaseUrl
                          }
                        ) : /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: "message-markdown",
                            style: { display: "flex", flexDirection: "column" },
                            dangerouslySetInnerHTML: { __html: marked.parse(content) }
                          }
                        ),
                        showCursor && /* @__PURE__ */ jsxs(Fragment, { children: [
                          /* @__PURE__ */ jsx("style", { children: `@keyframes cc-pulse{0%,100%{transform:scale(1)}50%{transform:scale(0.5)}}` }),
                          /* @__PURE__ */ jsx(
                            "span",
                            {
                              style: {
                                display: "inline-block",
                                width: "16px",
                                height: "16px",
                                backgroundColor: styles.streamingCursorColor ? resolveColor(styles.streamingCursorColor) : resolveColor(styles.textColor),
                                borderRadius: "50%",
                                marginLeft: "4px",
                                verticalAlign: "text-bottom",
                                animation: "cc-pulse 1s ease-in-out infinite"
                              }
                            }
                          )
                        ] }),
                        orders && orders.length > 0 && /* @__PURE__ */ jsx(OrderCardList, { orders })
                      ]
                    }
                  ),
                  bottomRef && /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        height: "1px",
                        width: "100%"
                      },
                      ref: bottomRef
                    }
                  ),
                  !isTyping && !isStreaming && content.length > 0 ? /* @__PURE__ */ jsxs(Actions, { className: "tw:mt-2", children: [
                    /* @__PURE__ */ jsx(
                      Action,
                      {
                        label: "Copy",
                        tooltip: copied ? "Response copied!" : "Copy response",
                        tooltipOpen: copied || void 0,
                        onClick: handleCopy,
                        children: /* @__PURE__ */ jsx(CopyIcon, {})
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Action,
                      {
                        label: "Like",
                        tooltip: liked ? "Thanks for your feedback!" : "Good response",
                        onClick: handleLike,
                        className: liked ? "tw:bg-[#DCDDDC]" : "",
                        children: /* @__PURE__ */ jsx(ThumbsUpIcon, { className: liked ? "tw:fill-current" : "" })
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Action,
                      {
                        label: "Dislike",
                        tooltip: disliked ? "Thanks for your feedback!" : "Bad response",
                        onClick: handleDislike,
                        className: disliked ? "tw:bg-[#DCDDDC]" : "",
                        children: /* @__PURE__ */ jsx(ThumbsDownIcon, { className: disliked ? "tw:fill-current" : "" })
                      }
                    ),
                    !isSharedView && /* @__PURE__ */ jsx(Action, { label: "Share", tooltip: "Share", onClick: handleShare, children: /* @__PURE__ */ jsx(ShareIcon, {}) }),
                    isLastMessage && !isSharedView && onRetry && /* @__PURE__ */ jsx(Action, { label: "Retry", tooltip: "Try again", onClick: () => onRetry(), children: /* @__PURE__ */ jsx(RetryIcon, {}) })
                  ] }) : null,
                  followUpsLoading && /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        padding: "4px 0 8px",
                        color: "var(--color-text-secondary, #9ca3af)",
                        fontSize: "13px",
                        letterSpacing: "0.1em"
                      },
                      children: "..."
                    }
                  ),
                  !isTyping && !isStreaming && followUpQueries.length > 0 && !(nextUserMessage && !selectedFollowUp) && /* @__PURE__ */ jsx(FollowUpQueriesWidget, { widgetId: "concierge-follow-up-queries", displayName: "Follow-up Suggestions", children: (widgetStyles, resolveColor2) => {
                    const isDisabled = !isLastMessage || !!selectedFollowUp;
                    const hex = (c) => !c || c.startsWith("#") || c.startsWith("rgb") ? c : `#${c}`;
                    const defaultBg = hex(resolveColor2(widgetStyles.pillBgColor));
                    const defaultText = hex(resolveColor2(widgetStyles.pillTextColor));
                    const defaultBorder = hex(resolveColor2(widgetStyles.pillBorderColor));
                    const hoverBg = defaultText;
                    const hoverText = defaultBg;
                    const hoverBorder = defaultText;
                    const selectedBg = hex(resolveColor2(widgetStyles.pillBgColorSelected));
                    const selectedText = hex(resolveColor2(widgetStyles.pillTextColorSelected));
                    const selectedBorder = hex(resolveColor2(widgetStyles.pillBorderColorSelected));
                    return /* @__PURE__ */ jsxs(
                      "div",
                      {
                        className: "fuq-wrap",
                        style: {
                          display: "flex",
                          flexWrap: "wrap",
                          marginTop: 16,
                          gap: `${widgetStyles.containerGap}px`,
                          width: "100%"
                        },
                        children: [
                          /* @__PURE__ */ jsx("style", { children: `
                          .fuq-wrap .fuq-pill {
                            background-color: ${defaultBg};
                            color: ${defaultText};
                            border-color: ${defaultBorder};
                            transition: all 0.2s ease;
                          }
                          .fuq-wrap .fuq-pill:not(:disabled):not(.fuq-selected):hover {
                            background-color: ${hoverBg};
                            color: ${hoverText};
                            border-color: ${hoverBorder};
                          }
                          .fuq-wrap .fuq-pill.fuq-selected {
                            background-color: ${selectedBg};
                            color: ${selectedText};
                            border-color: ${selectedBorder};
                          }
                        ` }),
                          followUpQueries.map((query, index) => {
                            const isSelected = selectedFollowUp === query;
                            return /* @__PURE__ */ jsx(
                              "button",
                              {
                                className: `fuq-pill${isSelected ? " fuq-selected" : ""}`,
                                onClick: () => handleFollowUpClick(query),
                                disabled: isDisabled && !isSelected,
                                style: {
                                  padding: `${widgetStyles.pillPaddingY}px ${widgetStyles.pillPaddingX}px`,
                                  borderRadius: `${widgetStyles.pillBorderRadius}px`,
                                  borderWidth: widgetStyles.pillBorderWidth,
                                  borderStyle: "solid",
                                  fontSize: `${widgetStyles.pillFontSize}px`,
                                  fontWeight: widgetStyles.pillFontWeight,
                                  lineHeight: "22px",
                                  textAlign: "left",
                                  cursor: isSelected ? "default" : isDisabled ? "not-allowed" : "pointer",
                                  opacity: !isSelected && isDisabled ? 0.5 : 1
                                },
                                children: query
                              },
                              index
                            );
                          })
                        ]
                      }
                    );
                  } })
                ]
              }
            )
          }
        )
      }
    );
    if (isStreaming && !isTyping && !hasAnyContent) return null;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: `message ${role}`,
        style: {
          display: "flex",
          flexDirection: "column",
          width: "100%"
        },
        children: [
          !isUser && devInfo && /* @__PURE__ */ jsx(DevInfoPanel, { devInfo }),
          !isUser && (storeLocator || streamingStoreLocator) && /* @__PURE__ */ jsx(
            StoreLocatorWidget,
            {
              stacklineSkus: ((_a = storeLocator || streamingStoreLocator) == null ? void 0 : _a.stacklineSkus) || [],
              apiUrl: apiBaseUrl
            }
          ),
          !isUser && (isTyping || shimmerActive) && /* @__PURE__ */ jsx(ChainOfThoughtWidget, { widgetId: "chain-of-thought", displayName: "Chain of Thought", children: (styles, resolveColor) => styles.thinkingEnabled ? /* @__PURE__ */ jsx("div", { style: { maxWidth: "100%" }, children: /* @__PURE__ */ jsx(
            "div",
            {
              className: "message-content",
              style: {
                maxWidth: "100%",
                backgroundColor: "none",
                color: resolveColor(styles.thinkingTextColor),
                borderRadius: `${styles.thinkingBorderRadius}px`,
                borderBottomLeftRadius: `${styles.thinkingBorderRadiusBottomLeft}px`,
                borderBottomRightRadius: `${styles.thinkingBorderRadius}px`,
                wordWrap: "break-word",
                padding: `${styles.thinkingPaddingY}px ${styles.thinkingPaddingX}px`
              },
              children: /* @__PURE__ */ jsx(
                Shimmer,
                {
                  as: "p",
                  style: { fontSize: `${styles.thinkingTextFontSize}px`, fontFamily: "inherit" },
                  duration: styles.shimmerDuration,
                  color: resolveColor(styles.thinkingTextColor),
                  highlightColor: resolveColor(styles.shimmerColor),
                  children: transientStatus && transientStatus !== "thinking" ? transientStatus : styles.thinkingText
                }
              )
            }
          ) }) : null }),
          isUser && hasUiMessageParts && (() => {
            const imageFiles = uiMessageParts.filter(
              (p) => {
                var _a2;
                return p.type === "file" && ((_a2 = p.mediaType) == null ? void 0 : _a2.startsWith("image/"));
              }
            );
            if (imageFiles.length === 0) return null;
            return /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "flex-end",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                  width: "100%",
                  marginBottom: "0.5rem"
                },
                children: imageFiles.map((fp, i) => /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: fp.url,
                    alt: fp.filename || "Uploaded image",
                    style: {
                      maxWidth: imageFiles.length === 1 ? "70%" : "45%",
                      maxHeight: "300px",
                      objectFit: "cover",
                      display: "block",
                      borderRadius: "12px"
                    }
                  },
                  i
                ))
              }
            );
          })(),
          !isTyping && (isUser ? renderUserMessageBubble() : renderAssistantMessageBubble())
        ]
      }
    );
  }
);
function uiPartsFingerprint(parts) {
  if (!(parts == null ? void 0 : parts.length)) return "";
  return `${parts.length}:${parts.map((p) => {
    var _a, _b;
    if (p.type === "text") return `text|${((_a = p.text) == null ? void 0 : _a.length) ?? 0}`;
    if (p.type === "data-product-carousels" || p.type === "data-section") return `ds|${((_b = p.data) == null ? void 0 : _b.title) ?? ""}`;
    return `${p.type}|${p.state ?? ""}`;
  }).join(",")}`;
}
const ChatMessage = React__default.memo(ChatMessageComponent, (prevProps, nextProps) => {
  var _a, _b;
  return prevProps.role === nextProps.role && prevProps.content === nextProps.content && prevProps.isTyping === nextProps.isTyping && prevProps.bottomRef === nextProps.bottomRef && prevProps.isStreaming === nextProps.isStreaming && prevProps.isLastMessage === nextProps.isLastMessage && ((_a = prevProps.followUpQueries) == null ? void 0 : _a.length) === ((_b = nextProps.followUpQueries) == null ? void 0 : _b.length) && prevProps.nextUserMessage === nextProps.nextUserMessage && prevProps.storeLocator === nextProps.storeLocator && prevProps.streamingStoreLocator === nextProps.streamingStoreLocator && prevProps.orders === nextProps.orders && prevProps.onSearch === nextProps.onSearch && prevProps.onVariantSelect === nextProps.onVariantSelect && prevProps.onSuggestionClick === nextProps.onSuggestionClick && uiPartsFingerprint(prevProps.uiMessageParts) === uiPartsFingerprint(nextProps.uiMessageParts);
});
export {
  ChatMessage
};
//# sourceMappingURL=ChatMessage.js.map
